var map = {
	"./angle-down-black.svg": 239,
	"./bin-danger.svg": 240,
	"./blocks.svg": 119,
	"./book.svg": 241,
	"./cancel-black.svg": 242,
	"./edit-line-primary.svg": 243,
	"./exit.svg": 244,
	"./freedom.svg": 245,
	"./holiday.svg": 246,
	"./menu.svg": 247,
	"./plus-line-primary.svg": 248,
	"./purchase.svg": 249,
	"./retirement.svg": 250,
	"./settings-primary.svg": 251,
	"./share-primary.svg": 252,
	"./share-white.svg": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 238;


//////////////////
// WEBPACK FOOTER
// ./src/icons ^\.\/.*\.svg$
// module id = 238
// module chunks = 0